import React from 'react';
type CtaButtonProps = {
  href: string;
  children: React.ReactNode;
  size?: 'md' | 'lg';
  className?: string;
};
export function CtaButton({
  href,
  children,
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-5 py-5 text-base sm:px-8 sm:text-lg md:text-xl' : 'px-5 py-4 text-sm sm:text-base md:text-lg';
  return <a href={href} className={`group relative inline-flex w-full max-w-xl items-center justify-center rounded-2xl border-b-4 border-gold-strong bg-gold font-extrabold uppercase tracking-wide text-brand shadow-[0_12px_30px_-12px_rgba(20,83,45,0.45)] transition-[transform,background-color] duration-150 ease-out hover:bg-gold-strong active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30 ${sizing} ${className}`} style={{
    width: "267px",
    height: "62px"
  }} data-id="element-25" data-mp="cmvo7s9ucfxp">
      <span className="block whitespace-nowrap px-7 text-center leading-none" style={{
      fontSize: "14px",
      textAlign: "left"
    }} data-id="element-26" data-mp="198yzpmabcz31">{children}</span>
    </a>;
}